import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonType } from '../../../../../ui/buttonTypes';
import StudentInfo from '../../shared/StudentInfo/StudentInfo';
import StatisticsCounters from '../../shared/StatisticsCounters/StatisticsCounters';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import classes from './StudentContestStage.module.css';

const StudentContestStage = () => {

    const { texts } = useSelector((state) => state.translate);
    const { achievements } = useSelector((state) => state.contest);

    return (
        <div className={classes.unregisteredStudentContestStage}>
            <div className={classes.rightAndMiddleWrapper}>
                <StudentInfo />
                <div className={classes.statisticsCountersWrapper}>
                    <StatisticsCounters
                        items={
                            [{ text: texts.topicStages, number: achievements.challenges, showStar: false },
                            { text: texts.topicStars, showStar: true, number: achievements.stars, }]
                        } />
                </div>
            </div>
            <div className={classes.btnWrapper}>
                <BtnComponent type={ButtonType.PLAY} text={texts.btnPlay} />
            </div>
        </div>
    );
};

export default StudentContestStage;

